import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPublicFeedsByCreatorUsername } from "../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchPublicFeeds = (username: string | null | undefined, activeTab: string | null) => {
  const dispatch = useDispatch<AppDispatch>();
  const { list, loading, error } = useSelector((state: StoreState) => state.feeds);

  useEffect(() => {
    if (username && activeTab === "feeds") {
      dispatch(getPublicFeedsByCreatorUsername(username));
    }
  }, [username, activeTab ,dispatch]);

  return { feedsLoading: loading, feedsError: error, publicFeeds: list };
};

export default useFetchPublicFeeds;
